import BaseModelComponent from '../../base/base_model_component';
import _ from '../../utils/underscore';
import ServiceFactory from '../../services/service_factory';

class RadioButtonModel extends BaseModelComponent {
	/**
	 * @static
	 * @type {string}
	 */
	static CLASS = 'RadioButtonModel';


	/**
	 *
	 * @param params
	 */
	init(params = {}) {
		this._setID(params.id)
			._setName(params.name)
			._setChecked(params.checked)
			._setLabel(params.labelkey);
	}

	_setID(id) {
		this._id = id || 'rb_test';

		return this;
	}

	_setName(name) {
		this._name = name || '';

		return this;
	}

	_setChecked(checked) {
		this._checked = checked === 'true';

		return this;
	}

	_setLabel(labelKey) {
		this._label = '';
		if(!_.isUndefined(labelKey) && labelKey !== '') {
			this._label = ServiceFactory.create().languageService().translation(labelKey);
		}

		return this;
	}

	getID() {
		return this._id;
	}

	getName() {
		return this._name;
	}

	isChecked() {
		return this._checked;
	}

	getLabel() {
		return this._label;
	}
}

export default RadioButtonModel;